import { useSyncExternalStore } from 'react';

let isCookieFooterVisible = false;
const listeners = new Set<() => void>();

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function getSnapshot() {
  return isCookieFooterVisible;
}

export function setCookieFooterVisible(visible: boolean) {
  if (isCookieFooterVisible === visible) {
    return;
  }

  isCookieFooterVisible = visible;
  listeners.forEach((listener) => listener());
}

export function useCookieFooterVisibility() {
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
